export default "/images/logo_cpmr_h.png?c3dbecfd8b9a75776ee682b5b48b0784";